/* eslint-disable default-param-last */
import * as actionTypes from 'actions/mapaActions'

const initialState = {
  dados: [],
}

const mapaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MAPA_ENDERECO:
      return {
        ...state,
        dados: action.dados,
      }
    default:
      return state
  }
}

export default mapaReducer
